import { Cid } from '../types';

export const defaultCid: Cid = { id: null, statusId: null, name: '' };
